export default "__VITE_ASSET__wPN9IVQQ__"